module.exports = __webpack_public_path__ + "img/wechat-img4.231b5351.png";